module.exports = __webpack_public_path__ + "img/mock_preview.c47f85d6.png";